import { Box, Chip } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const SuggestionChip = styled(Chip)`
  &.MuiChip-root {
    height: 24px;
  }
  .MuiChip-label {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const TitleContainer = styled(Box)`
  display: flex;
  gap: 8px;
  align-items: center;
  align-self: stretch;
`;
